<template>
    <button-plain-icon
        v-tooltip="tooltip"
        :disabled="!props.lead.canExecutionBeCancelled"
        :icon="icon"
        is-custom-icon
        style="align-self: flex-start"
        @click="onClick"
    />
    <lead-cancel-execution-confirmation-dialog
        :visible="confirmationVisible"
        @confirm="onConfirm"
        @cancel="confirmationVisible = false"
    />
</template>

<script setup lang="ts">
    import { computed, ref } from 'vue';
    import { CancelExecutionCommand, Lead } from '@keyvue/one-api-client';
    import useClient from '@/services/keyvue-api/composables/useClient';
    import useNotify from '@/services/keyvue-ui/composables/useNotify';
    import IconCancelExecution from '@/assets/icons/cancel-execution.svg?component';
    import IconCancelExecutionDisabled from '@/assets/icons/cancel-execution-disabled.svg?component';
    import LeadCancelExecutionConfirmationDialog from '@/flow/execution/components/LeadCancelExecutionConfirmationDialog.vue';

    const props = defineProps<{ lead: Lead }>();
    const { client } = useClient();
    const { notifySaved, notifyError } = useNotify();

    const confirmationVisible = ref(false);

    const canCancel = computed(() => {
        return props.lead.canExecutionBeCancelled;
    });

    const icon = computed(() => {
        return canCancel.value ? IconCancelExecution : IconCancelExecutionDisabled;
    });

    const tooltip = computed(() => {
        return canCancel.value ? 'Uitschrijven' : 'Uitschrijven is niet mogelijk voor niet lopende flows';
    });

    function onClick() {
        confirmationVisible.value = true;
    }

    async function onConfirm() {
        if (!canCancel.value) {
            return;
        }

        try {
            await client.dispatch(new CancelExecutionCommand(props.lead.executionId));
            notifySaved(undefined, 'De contactpersoon is uitgeschreven voor deze flow');
            confirmationVisible.value = false;
        } catch (error) {
            notifyError(error);
        }
    }
</script>
